import * as Constants from "../constants/FoodConstants"

export const storeFoodData = (payload:any) => {
    return {
        type:Constants.STORE_FOOD_DATA,
        data:payload
    }
}

export const storeStaticData = (payload:any) => {
    return {
        type:Constants.STORE_STATIC_DATA,
        data:payload
    }
}

export const storeDynamicData = (payload:any) => {
    return{
        type:Constants.STORE_DYNAMIC_DATA,
        data:payload
    }
}

export const clearFoodData = (payload:any) => {
    return{
        type:Constants.CLEAR_FOOD_DATA,
        data:payload
    }
}
